import { buildPayrollPdfDocumentDefinition } from "./buildPayrollPdfDocument";
import { exportReportPdf } from "../shared/pdfMakeClient";
import { buildPayrollPdfFilename } from "../shared/reportPdfFilenames";
import { prepareReportPdfBranding } from "../../helpers/prepareReportPdfBranding";

export async function downloadPayrollReportPdf(reportModel, { branding } = {}) {
  if (!reportModel) {
    throw new Error("Report model is required");
  }

  const { branding: resolvedBranding, logoDataUrl } =
    await prepareReportPdfBranding(branding);

  const docDefinition = buildPayrollPdfDocumentDefinition(reportModel, {
    logoDataUrl,
    branding: resolvedBranding,
  });

  const filename = buildPayrollPdfFilename(reportModel);

  await exportReportPdf(
    docDefinition,
    filename,
    `Payroll Report — ${reportModel.header?.employeeName || "Report"}`,
  );
}
